import { render, staticRenderFns } from "./ArchiInfo.vue?vue&type=template&id=08c52e3f&scoped=true"
import script from "./ArchiInfo.vue?vue&type=script&lang=js"
export * from "./ArchiInfo.vue?vue&type=script&lang=js"
import style0 from "./ArchiInfo.vue?vue&type=style&index=0&id=08c52e3f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c52e3f",
  null
  
)

export default component.exports